import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Image, View } from 'react-native'

import Text from '@common/components/Text'
import useTheme from '@common/hooks/useTheme'
import spacings from '@common/styles/spacings'
import flexbox from '@common/styles/utils/flexbox'
import useResponsiveActionWindow from '@web/hooks/useResponsiveActionWindow'

import getStyles from './styles'

interface Props {
  name?: string
  icon?: string
  intentText: string
}

const RequestingDappInfo: FC<Props> = ({ name, icon, intentText }) => {
  const { t } = useTranslation()
  const { styles, theme } = useTheme(getStyles)
  const { responsiveSizeMultiplier } = useResponsiveActionWindow()
  const size = 48 * responsiveSizeMultiplier

  return (
    <View style={flexbox.directionRow}>
      {icon ? (
        <Image
          source={{ uri: icon }}
          style={{
            ...styles.image,
            width: size,
            height: size
          }}
          resizeMode="contain"
        />
      ) : (
        // Visible letter-avatar fallback (dapp didn't provide an icon).
        <View
          style={{
            width: size,
            height: size,
            borderRadius: 12,
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.accentChipDecorative as string
          }}
        >
          <Text
            fontSize={20 * responsiveSizeMultiplier}
            weight="semiBold"
            color={theme.white as string}
          >
            {(name || 'A').charAt(0).toUpperCase()}
          </Text>
        </View>
      )}
      <View style={[flexbox.flex1, spacings.mlSm]}>
        <Text fontSize={16 * responsiveSizeMultiplier} appearance="secondaryText" weight="semiBold">
          {name || t('The App')}
        </Text>
        <Text fontSize={14 * responsiveSizeMultiplier} appearance="secondaryText">
          {intentText}
        </Text>
      </View>
    </View>
  )
}

export default React.memo(RequestingDappInfo)
